import { createContext, useContext, ReactNode } from 'react';
import { useEODForm } from '@/hooks/useEODForm';
import { EODFormModal } from './EODFormModal';

interface EODContextType {
  openForm: (editing?: boolean) => void;
  submissions: ReturnType<typeof useEODForm>['submissions'];
  todaySubmission: ReturnType<typeof useEODForm>['todaySubmission'];
  getSubmissionByDate: ReturnType<typeof useEODForm>['getSubmissionByDate'];
}

const EODContext = createContext<EODContextType | null>(null);

export function useEODContext() {
  const context = useContext(EODContext);
  if (!context) {
    throw new Error('useEODContext must be used within EODProvider');
  }
  return context;
}

export function EODProvider({ children }: { children: ReactNode }) {
  const {
    isOpen,
    submissions,
    todaySubmission,
    isEditing,
    submitEOD,
    skipToday,
    openForm,
    closeForm,
    saveDraft,
    loadDraft,
    clearDraft,
    getSubmissionByDate
  } = useEODForm();

  return (
    <EODContext.Provider value={{ openForm, submissions, todaySubmission, getSubmissionByDate }}>
      {children}
      <EODFormModal
        isOpen={isOpen}
        onClose={closeForm}
        onSubmit={submitEOD}
        onSkip={skipToday}
        existingSubmission={todaySubmission}
        isEditing={isEditing}
        saveDraft={saveDraft}
        loadDraft={loadDraft}
        clearDraft={clearDraft}
      />
    </EODContext.Provider>
  );
}
